import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Book = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/book">
        <g id="book">
          <path
            id="Vector"
            d="M7.9987 14.72C7.7987 14.72 7.5987 14.6733 7.43203 14.58C6.18536 13.9 3.99203 13.18 2.6187 13L2.42536 12.9733C1.55203 12.8666 0.832031 12.0466 0.832031 11.16V3.10663C0.832031 2.57996 1.0387 2.09996 1.4187 1.7533C1.7987 1.40663 2.29203 1.23996 2.81203 1.28663C4.2787 1.39996 6.49203 2.1333 7.74536 2.91996L7.90536 3.0133C7.95203 3.03996 8.05203 3.03996 8.09203 3.01996L8.1987 2.9533C9.45203 2.16663 11.6654 1.41996 13.1387 1.2933C13.152 1.2933 13.2054 1.2933 13.2187 1.2933C13.7054 1.24663 14.2054 1.41996 14.5787 1.76663C14.9587 2.1133 15.1654 2.5933 15.1654 3.11996V11.1666C15.1654 12.06 14.4454 12.8733 13.5654 12.98L13.3454 13.0066C11.972 13.1866 9.77203 13.9133 8.55203 14.5866C8.39203 14.68 8.1987 14.72 7.9987 14.72ZM2.65203 2.27996C2.4387 2.27996 2.24536 2.3533 2.09203 2.4933C1.92536 2.64663 1.83203 2.86663 1.83203 3.10663V11.16C1.83203 11.5533 2.17203 11.9333 2.55203 11.9866L2.75203 12.0133C4.25203 12.2133 6.55203 12.9666 7.88536 13.6933C7.94536 13.72 8.03203 13.7266 8.06536 13.7133C9.3987 12.9733 11.712 12.2133 13.2187 12.0133L13.4454 11.9866C13.8254 11.94 14.1654 11.5533 14.1654 11.16V3.1133C14.1654 2.86663 14.072 2.6533 13.9054 2.4933C13.732 2.33996 13.512 2.26663 13.2654 2.27996C13.252 2.27996 13.1987 2.27996 13.1854 2.27996C11.912 2.3933 9.8587 3.07996 8.7387 3.77996L8.63203 3.8533C8.26536 4.07996 7.74536 4.07996 7.39203 3.85996L7.23203 3.76663C6.09203 3.06663 4.0387 2.38663 2.73203 2.27996C2.70536 2.27996 2.6787 2.27996 2.65203 2.27996Z"
          />
          <path
            id="Vector_2"
            d="M8 14.16C7.72667 14.16 7.5 13.9334 7.5 13.66V3.66003C7.5 3.3867 7.72667 3.16003 8 3.16003C8.27333 3.16003 8.5 3.3867 8.5 3.66003V13.66C8.5 13.94 8.27333 14.16 8 14.16Z"
          />
          <path
            id="Vector_3"
            d="M5.16797 6.16003H3.66797C3.39464 6.16003 3.16797 5.93337 3.16797 5.66003C3.16797 5.3867 3.39464 5.16003 3.66797 5.16003H5.16797C5.4413 5.16003 5.66797 5.3867 5.66797 5.66003C5.66797 5.93337 5.4413 6.16003 5.16797 6.16003Z"
          />
          <path
            id="Vector_4"
            d="M5.66797 8.16003H3.66797C3.39464 8.16003 3.16797 7.93337 3.16797 7.66003C3.16797 7.3867 3.39464 7.16003 3.66797 7.16003H5.66797C5.9413 7.16003 6.16797 7.3867 6.16797 7.66003C6.16797 7.93337 5.9413 8.16003 5.66797 8.16003Z"
          />
        </g>
      </g>
    </svg>
  );
};

Book.displayName = 'Book';
